module.exports = __webpack_public_path__ + "static/media/29BDOS27.823af8a1.jpg";